
import { defineComponent } from "vue";
import { AffiliateLabProduct } from "@/interfaces/AffiliateLabProduct";

export default defineComponent({
  name: "labProductChoice",

  data() {
    return {
      openSections: {} as any,
      productLab: [
        {
          id: 1,
          affiliateID: 6,
          questionnaireTypeID: 13,
          labID: 45,
          fillQty: 1,
          type: "At-home",
          labName: "Testosterone Panel",
          description: "A comprehensive hormone check-in for energy, strength, and sexual health.",
          price: 0,
          contentJSON: {
            order: 0,
            titleOverride: "Testosterone Panel",
            oldPrice: 99,
            freeText: "INCLUDED",
            tag: {
              type: "At-home test",
              icon: "house",
            },
            learn: ["Energy & fatigue patterns", "Libido and sexual health trends", "Muscle strength & recovery", "Mood and motivation clues"],
            biomarkers: ["Total Testosterone", "Free Testosterone", "SHBG", "LH", "FSH", "Estradiol (E2)", "DHEA-S", "Prolactin", "Albumin", "Hematocrit"],
            sections: [
              {
                title: "What you’ll learn",
                contentList: ["Energy & fatigue patterns", "Libido and sexual health trends", "Muscle strength & recovery", "Mood and motivation clues"],
              },
              {
                title: "Included Biomarkers",
                contentList: ["Total Testosterone", "Free Testosterone", "SHBG", "LH", "FSH", "Estradiol (E2)", "DHEA-S", "Prolactin", "Albumin", "Hematocrit"],
                maxHeight: "560px",
              },
              {
                title: "How this works",
                contentList: "<p>Collect your sample at home, ship it back using the pre-paid label, and get results in 3–5 days.</p><p><strong>No fasting required.</strong></p>",
              },
            ],
          },
          active: true,
          isMandatory: true,
        },
        {
          id: 2,
          affiliateID: 6,
          questionnaireTypeID: 13,
          labID: 45,
          fillQty: 1,
          type: "At-home",
          labName: "Testosterone Panel",
          description: "A comprehensive hormone check-in for energy, strength, and sexual health.",
          price: 99,
          contentJSON: {
            order: 0,
            titleOverride: "Testosterone Panel",
            oldPrice: 99,
            freeText: "INCLUDED",
            tag: {
              type: "At-home test",
              icon: "house",
            },
            sections: [
              {
                title: "What you’ll learn",
                contentList: ["Energy & fatigue patterns", "Libido and sexual health trends", "Muscle strength & recovery", "Mood and motivation clues"],
              },
              {
                title: "Included Biomarkers",
                contentList: ["Total Testosterone", "Free Testosterone", "SHBG", "LH", "FSH", "Estradiol (E2)", "DHEA-S", "Prolactin", "Albumin", "Hematocrit"],
              },
              {
                title: "How this works",
                contentList: "<p>Collect your sample at home, ship it back using the pre-paid label, and get results in 3–5 days.</p><p><strong>No fasting required.</strong></p>",
              },
            ],
          },
          active: true,
          isMandatory: false,
        },
        {
          id: 3,
          affiliateID: 6,
          questionnaireTypeID: 13,
          labID: 45,
          fillQty: 1,
          type: "At-home",
          labName: "Testosterone Panel",
          description: "A comprehensive hormone check-in for energy, strength, and sexual health.",
          price: 79,
          contentJSON: {
            order: 0,
            titleOverride: "Testosterone Panel",
            oldPrice: 99,
            freeText: "INCLUDED",
            tag: {
              type: "At-home test",
              icon: "house",
            },
            learn: ["Energy & fatigue patterns", "Libido and sexual health trends", "Muscle strength & recovery", "Mood and motivation clues"],
            biomarkers: ["Total Testosterone", "Free Testosterone", "SHBG", "LH", "FSH", "Estradiol (E2)", "DHEA-S", "Prolactin", "Albumin", "Hematocrit"],
            sections: [
              {
                title: "What you’ll learn",
                contentList: ["Energy & fatigue patterns", "Libido and sexual health trends", "Muscle strength & recovery", "Mood and motivation clues"],
              },
              {
                title: "Included Biomarkers",
                contentList: ["Total Testosterone", "Free Testosterone", "SHBG", "LH", "FSH", "Estradiol (E2)", "DHEA-S", "Prolactin", "Albumin", "Hematocrit"],
                maxHeight: "560px",
              },
              {
                title: "How this works",
                contentList: "<p>Collect your sample at home, ship it back using the pre-paid label, and get results in 3–5 days.</p><p><strong>No fasting required.</strong></p>",
              },
            ],
          },
          active: true,
          isMandatory: false,
        },
      ],
      filteredLabs: [] as AffiliateLabProduct[],
      selectedLabs: [] as AffiliateLabProduct[],
    };
  },
  mounted() {
    this.setfilteredLabs();
  },
  methods: {
    isOpen(id: string) {
      return !!this.openSections[id];
    },
    toggle(id: string) {
      this.$set(this.openSections, id, !this.openSections[id]);
    },
    setfilteredLabs() {
      const l = this.productLab
        .filter((x) => x.questionnaireTypeID == 13)
        .sort((a, b) => {
          if (this.getOrder(a.contentJSON) < this.getOrder(b.contentJSON)) return -1;
          else return 1;
        });
      this.filteredLabs = l;
    },
    getOrder(contentJSON: any) {
      if (contentJSON) {
        return contentJSON.order ? contentJSON.order : 0;
      }
      return 0;
    },
    getTypeTagText(contentJSON: any) {
      if (contentJSON) {
        return contentJSON.tag.type;
      }
      return null;
    },
    getTypeTagIcon(contentJSON: any) {
      if (contentJSON) {
        return contentJSON.tag.icon;
      }
      return null;
    },
    getTitleOverride(contentJSON: any) {
      if (contentJSON) {
        return contentJSON.titleOverride;
      }
      return null;
    },
    getOldPrice(contentJSON: any) {
      if (contentJSON) {
        return contentJSON.oldPrice;
      }
      return null;
    },
    getFreeText(contentJSON: any) {
      if (contentJSON) {
        return contentJSON.freeText;
      }
      return null;
    },
    isSelected(lab) {
      return this.selectedLabs.some((x) => x.id === lab.id);
    },
    removeLabById(id) {
      this.selectedLabs = this.selectedLabs.filter((x) => x.id !== id);
    },
    priceIsZero(price: any) {
      const isFree = price == null || Number(price) === 0;
      if (!isFree) return null;
      return;
    },
    updateSelectedLabs(lab: any) {
      if (lab.isMandatory) {
        return;
      }
      if (this.isSelected(lab)) {
        this.removeLabById(lab.id);
      } else {
        this.selectedLabs.push(lab);
      }
      console.log("Seleced Labs:", this.selectedLabs);
    },
  },
  components: {},
});
